














































import { Component, Prop, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { NewsApi } from "@/api/newsApi";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class ImageTextList extends Vue {
  newsApi = new NewsApi();
  dataList: Array<object> = [];
  // categorys: object;
  categoryId = 0;
  categoryName = "";
  pageNum = 1;
  listTotal = 0;

  constructor() {
    super();
    // this.categorys = { 10: "究酒99", 11: "名庄风采", 12: "高手在民间" };
  }

  mounted() {
    this.categoryId = Number(this.$route.query["category"]);
    this.categoryName = this.$route.query["categoryName"].toString();
    this.getDataList();
  }

  getDataList() {
    this.newsApi
      .getBasicContentByType(this.categoryId, this.pageNum, 9)
      .then((res) => {
        this.dataList = res.data;
        this.listTotal = res.total;
      });
  }

  changeListPage(page: number, pageSize: number) {
    this.pageNum = page;
    this.getDataList();
  }
}
